export default "__VITE_ASSET__CsJKrpRS__"